module.exports = __webpack_public_path__ + "img/image-x.0ff2b9e6.svg";